import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { fixRouteBidStatuses } from "helpers/enums";
import { paths } from "helpers/paths";
import { DateRangeColumnFilter, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import Tooltip from "rc-tooltip";
import React from "react";
import { Link } from "react-router-dom";
import { getAllUsersForSelectList, getOrganizationNames } from "sources/admin";
import { list as getDrivers } from "sources/books/admin/drivers";

export class FixRouteBidsList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            {
                Header: "ID",
                accessor: "id",
                width: 100,
                filterable: true,
                filterType: "int",
                Cell: ({ value, row }) => (
                    <span className="position-relative">
                        <Link to={paths.fixRouteBidsShow(value)}>{value}</Link>
                        {!!row.original.unreadMessagesCount && (
                            <Tooltip overlay="Количество непрочитанных сообщений">
                                <div className="book-tr__notifys-count book-tr__notifys-count--right">
                                    {row.original.unreadMessagesCount}
                                </div>
                            </Tooltip>
                        )}
                    </span>
                ),
                CSVExport: ({ value }) => value,
            },
            {
                Header: "Дата обращения",
                accessor: "createdAt",
                filterable: true,
                filterType: "dateTimeRange",
                sortable: true,
                Filter: DateRangeColumnFilter,
                Cell: ({ value }) => dateTimeToView(value),
                CSVExport: ({ value }) => dateTimeToView(value),
            },
            {
                Header: "Компания",
                accessor: "organizationName",
                id: "organizationId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getOrganizationNames,
                            inputProps: { name: "organizationId" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({ value, row: { original } }) => (
                    <Link to={paths.adminOrganizationsShow(original.organizationId)}>{value}</Link>
                ),
            },
            {
                Header: "Логист",
                accessor: "logistName",
                id: "logistId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getAllUsersForSelectList,
                            inputProps: { name: "logistId" },
                            propName: "fullNameOrEmail",
                        }}
                    />
                ),
            },
            {
                Header: "Водитель",
                accessor: "driverName",
                id: "driverId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ url: getDrivers, inputProps: { name: "driverId" }, propName: "fullName" }}
                    />
                ),
            },
            {
                Header: "Номер заявки",
                accessor: "bidId",
                filterable: true,
                filterType: "int",
                sortable: true,
                Cell: ({ value }) => <Link to={paths.bidShow("bid", value)}>{value}</Link>,
                CSVExport: ({ value }) => value,
            },
            {
                Header: "Статус",
                accessor: "status",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "status" },
                            options: fixRouteBidStatuses,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(fixRouteBidStatuses, value),
                CSVExport: ({ value }) => enumLabel(fixRouteBidStatuses, value),
            },
        ];
    }

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(FixRouteBidsList, "admin-fix-route-bids");
